import React, { useRef, useState } from "react";
import { useLoginMutation } from "../constants/redux/api/api";
import { useNavigate } from "react-router-dom";
import Keyboard from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";
import { Modal } from "react-bootstrap";

const LoginScreen = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [passwords, setPasswords] = useState([]);
  const [text, setText] = useState({});
  const [board, setBoard] = useState(false);
  const [boards, setBoards] = useState(false);

  const [usernameErr, setUsernameErr] = useState("");
  const [passwordErr, setPasswordErr] = useState("");

  //   RTK QUERY
  const [login] = useLoginMutation();

  const onTextChanger = (event) => {
    const name = event.target.name;
    const value = event.target.value;
  };

  const [input, setInput] = useState("");
  const [layout, setLayout] = useState("default");
  const [layouts, setLayouts] = useState("default");
  const keyboard = useRef();
  const keyboards = useRef();

  const onChange = (input) => {
    setInput(input);
    setUsername(input);
  };
  const onChanges = (input) => {
    setPassword(input);
    let temp = [];
    for (let i = 0; i < input?.length; i++) {
      temp.push(".");
    }
    setPasswords(temp);
  };

  const handleShift = () => {
    const newLayoutName = layout === "default" ? "shift" : "default";
    setLayout(newLayoutName);
  };

  const handleShifts = () => {
    const newLayoutName = layout === "default" ? "shift" : "default";
    setLayouts(newLayoutName);
  };

  const onKeyPress = (button) => {
    // console.log("Button pressed", button);

    /**
     * If you want to handle the shift and caps lock buttons
     */
    if (button === "{shift}" || button === "{lock}") handleShift();
  };

  const onKeyPress2 = (button) => {
    // console.log("Button pressed", button);

    /**
     * If you want to handle the shift and caps lock buttons
     */
    if (button === "{shift}" || button === "{lock}") handleShifts();
  };

  const onChangeInput = (event) => {
    const input = event.target.value;
    setInput(input);
    keyboard.current.setInput(input);
  };

  const onSubmit = () => {
    if (username === "" || password === "") {
      setUsernameErr(true);
      setPasswordErr(true);
    } else {
      const data = {
        name: username,
        password: password,
      };
      login(data)
        .unwrap()
        .then((res) => {
          if (res?.status === "success") {
            // console.log(res);
            localStorage.setItem("token", res?.result?.token);
            localStorage.setItem("user_details", JSON.stringify(res?.result));
            localStorage.setItem(
              "name",
              res?.result?.robots_name || res?.result?.name
            );
            if (res?.result?.role === "admin") {
              navigate("/admin-menu");
            } else if (res?.result?.robots_id) {
              navigate("/welcome");
            }
          }
        })
        .catch((err) => console.log(err));
    }
  };

  return (
    <div className="login">
      <div className=" ">
        <div className="right_log">
          <h1>Login</h1>
          <p>Welcome back! Login to access your account</p>

          <div className="form">
            <div>
              {" "}
              {!board && (
                <button
                  className="form-control form-cl text-start"
                  onClick={() => {
                    setBoard(true);
                    setBoards(false);
                  }}
                >
                  {username ? username : "Enter your username"}
                </button>
              )}
              {board && (
                <input
                  className="form-control form-cl"
                  placeholder="Enter your username"
                  type="text"
                  name="username"
                  value={username}
                />
              )}
            </div>
            <div>
              {!boards && (
                <button
                  className="form-control form-cl text-start"
                  onClick={() => {
                    setBoards(true);
                    setBoard(false);
                  }}
                >
                  {password
                    ? passwords?.map((item) => item)
                    : "Enter your password"}
                </button>
              )}
              {boards && (
                <input
                  className="form-control form-cl"
                  placeholder="Enter your password"
                  type="password"
                  name="password"
                  value={password}
                />
              )}
            </div>
            <div onClick={onSubmit} className="login_btn text-center">
              <button className="bt_sub">Continue</button>
            </div>

            <div className="bt_center text-center">
              <p>
                New to Team Robotics? <button>Create account</button>
              </p>
            </div>
          </div>
        </div>
        {board && (
          <div
            className="key_board"
            style={{
              position: "fixed",
              left: 0,
              bottom: 0,
              width: "100%",
            }}
          >
            <div
              style={{
                float: "right",
                border: "1px solid black",
                borderRadius: "100%",
                width: "30px",
                height: "28px",
              }}
            >
              <p style={{ marginLeft: "10px" }} onClick={() => setBoard(false)}>
                x
              </p>
            </div>
            <Keyboard
              keyboardRef={(r) => (keyboard.current = r)}
              layoutName={layout}
              onChange={onChange}
              onKeyPress={onKeyPress}
            />
          </div>
        )}
        {boards && (
          <div
            className="key_board"
            style={{
              position: "fixed",
              left: 0,
              bottom: 0,
              width: "100%",
            }}
          >
            <div
              style={{
                float: "right",
                border: "1px solid black",
                borderRadius: "100%",
                width: "30px",
                height: "28px",
              }}
            >
              <p
                style={{ marginLeft: "10px" }}
                onClick={() => setBoards(false)}
              >
                x
              </p>
            </div>
            <Keyboard
              keyboardRef={(r) => (keyboards.current = r)}
              layoutName={layouts}
              onChange={onChanges}
              onKeyPress={onKeyPress2}
            />
          </div>
        )}
        {/* <Modal show={boards} onHide={() => setBoards(false)}>
          <Keyboard
            keyboardRef={(r) => (keyboards.current = r)}
            layoutName={layouts}
            onChange={onChanges}
            onKeyPress={onKeyPress2}
          />
        </Modal> */}
      </div>
    </div>
  );
};

export default LoginScreen;
